import React from "react";
import { observer } from "mobx-react";
import { EditionContractPublisherViewStore } from "../../store";
import { EditionContractPublisherViewForm } from "./EditionContractPublisherViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type EditionContractPublisherViewProps = {
  editionContractPublisherViewStore: EditionContractPublisherViewStore;
};

export const EditionContractPublisherView: React.FC<EditionContractPublisherViewProps> =
  observer(({ editionContractPublisherViewStore }) => {
    return (
      <div>
        <EditionContractPublisherViewForm
          publisherValue={editionContractPublisherViewStore.publisherValue}
          percentage={editionContractPublisherViewStore.percentageValue}
          onPrint={(handlePrint: () => void) =>
            editionContractPublisherViewStore.printEditionContractPublisher(
              handlePrint
            )
          }
          onCancel={() =>
            editionContractPublisherViewStore.cancelEditionContractPublisher()
          }
          onEdit={
            editionContractPublisherViewStore.isEditEnabled
              ? () =>
                  editionContractPublisherViewStore.editEditionContractPublisher()
              : undefined
          }
        />
        <ErrorDialog
          open={editionContractPublisherViewStore.errorDialogOpened}
          title={editionContractPublisherViewStore.errorTitle}
          description={editionContractPublisherViewStore.errorDescription}
          onClose={() => editionContractPublisherViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
